import request from '@/utils/httpRequest'

export function login (data) {
  return request({
    url: `/adminLogin`,
    method: 'post',
    data
  })
}
export function getUserInfo () {
  return request({
    url: `/sys/user/info`,
    method: 'get',
    params: {}
  })
}
export function changePassword (data) {
  return request({
    url: `/sys/user/password`,
    method: 'post',
    data
  })
}
